import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Release\GetReleaseListController::__invoke
* @see app/Http/Controllers/Release/GetReleaseListController.php
* @route '/api/sa-management/release'
*/
const GetReleaseListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetReleaseListController.url(options),
    method: 'get',
})

GetReleaseListController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/release',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Release\GetReleaseListController::__invoke
* @see app/Http/Controllers/Release/GetReleaseListController.php
* @route '/api/sa-management/release'
*/
GetReleaseListController.url = (options?: RouteQueryOptions) => {
    return GetReleaseListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Release\GetReleaseListController::__invoke
* @see app/Http/Controllers/Release/GetReleaseListController.php
* @route '/api/sa-management/release'
*/
GetReleaseListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetReleaseListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Release\GetReleaseListController::__invoke
* @see app/Http/Controllers/Release/GetReleaseListController.php
* @route '/api/sa-management/release'
*/
GetReleaseListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetReleaseListController.url(options),
    method: 'head',
})

export default GetReleaseListController